import Component from "../../../lib/component";
import template from './remind-todo.html'
import './remind-todo.scss'
import Mediator from '../../../lib/mediator';
import dataTimeControl from '../../form/datetime-control/datetime-control'
import {AutoSelect} from '../../util/autoSelect/autoSelect'
import '../../../assets/scss/core/common.scss';
import {FormService} from '../../../services/formService/formService'
import CycleSettings from './remind-cycle-settings/remind-cycle-settings';
import {PMAPI} from "../../../lib/postmsg";
import {HTTP} from "../../../lib/http";
import MSG from '../../../lib/msgbox';

let config = {
    template: template,
    data: {
        obj:{},
        cycle:'一次', //提醒周期,
        reminder:new Set(), //提醒方式
        translatecycle:{
          '一次':'time',
          '每天':'day',
          '每周':'week',
          '每月':'month',
        },
        monthArr:['月份按天提醒','月份按星期提醒','提醒星期'],
        cycleMonth:'按天提醒',
        monthSettings:{   //每月提醒方式
            '按天提醒':['月份按星期提醒','提醒星期'],
            '按星期提醒':['月份按天提醒']
        },
        departmentData:[],
        choosedUsers:[],
        formData:{},
        is_view:false,
        ignoreFields : ['_id','f1', 'f2', 'f3', 'f4'],
        ignoreLabels :['提醒描述','结束时间','提醒规则设置'],
        postData:{},
        sender:"",
        separator:'——'
    },
    binds: [
        //下一页
        {
            event: 'click',
            selector: '.toNext',
            callback() {
                this.el.find('.basic-wrap').hide();
                this.el.find('.remind-wrap').show();
            }
        },
        //上一页
        {
            event: 'click',
            selector: '.toPre',
            callback() {
                this.el.find('.remind-wrap').hide();
                this.el.find('.basic-wrap').show();
            }
        },
        {
            event: 'keyup',
            selector: 'input[type="text"],textarea',
            callback:_.debounce(function (e) {
                let label = $(e).parent('.form-group').attr('data-label');
                this.actions.changeValue(label,e.value);
            },300)
        },
        {
            event: 'click',
            selector: 'input[type="radio"]',
            callback:_.debounce(function (e) {
                let label = $(e).attr('name');
                this.actions.changeValue(label,e.value);
                if(label == '提醒周期'){
                    if(e.value != this.data.cycle) {
                        this.data.cycle = $(e).attr('data-label');
                        this.actions.renderCycleSettings(this.data.cycle);
                    }
                }else if(label == '每月提醒方式') {
                    this.data.cycleMonth =  $(e).attr('data-label');
                    this.actions.requireMonthSettings();
                }
            },300)
        },
        {
            event: 'click',
            selector: 'input[name="提醒方式"]',
            callback:_.debounce(function (e) {
                let label = $(e).attr('name');
                e.checked ? this.data.reminder.add(e.value) : this.data.reminder.delete(e.value);
                this.actions.changeValue(label,Array.from(this.data.reminder));
            },300)
        },
        {
            event: 'click',
            selector: '.addUsers',
            callback() {
                this.actions.getDepartmentData();
            }
        },
        //保存
        {
            event: 'click',
            selector: '#save',
            callback() {
                if(!this.data.isBtnClick) {
                    this.data.isBtnClick = true;
                    this.actions.submitData();
                }
            }
        },
        //取消
        {
            event: 'click',
            selector: '.cancel',
            callback() {
                agGridOpenForm.hide();
            }
        }
    ],
    actions: {
       async createFormData() {
           await this.actions.getFormId();
           let obj = this.data.obj;
           let postData = {
               form_id: obj.form_id,
               table_id:obj.table_id,
               is_view:obj.is_view,
               parent_table_id:obj.parent_table_id,
               parent_real_id:obj. parent_real_id,
               parent_temp_id:obj.parent_temp_id,
               real_id:obj.real_id,
           }
           this.data.postData = postData;
           let res =await FormService.getFormData(postData);
           let staticData =await this.actions.mergeFormData(res[0],res[1]);
           this.data.data = staticData;
           let formData = this.data.formData = staticData.formData;
           this.actions.initValue(res,formData );
           await this.actions.initControls();
           this.actions.initControlsValue();
           this.hideLoading();
        },
        //获取表单的form_id
        async getFormId(){
            if (!this.data.obj.form_id) {
                let res = await  FormService.getPrepareParmas({table_id: this.data.obj.table_id});
                this.data.obj.form_id = res.data.form_id;
            }
        },
        mergeFormData(staticData, dynamicData) {
            staticData.formData = {}
            let ignoreFields = this.data.ignoreFields;
            for (let dfield in dynamicData["data"]) {
                if (this.actions.hasKeyInFormDataStatic(dfield, staticData)) {
                    for (let dict of staticData["data"]) {
                        if (dict["dfield"] == dfield) {
                            for (let k in dynamicData["data"][dfield]) {
                                dict[k] = dynamicData["data"][dfield][k];
                                staticData.formData[dict['label']] = dict;
                            }
                        }
                    }
                } else {
                    staticData["data"].push(dynamicData["data"][dfield]);
                }
            }
            return staticData;
        },
        //静态数据里是否有这个key
        hasKeyInFormDataStatic(key, staticData) {
            let isExist = false;
            for (let dict of staticData["data"]) {
                if (dict["dfield"] == key) {
                    isExist = true;
                }
            }
            return isExist;
        },
        //组件回显
        initControlsValue(){
            let formData = this.data.formData;
            let $el = this.el;
            for(let key in formData) {
                let data = formData[key];
                let type = data.type;
                if (type == 'Input') {
                    $el.find(`.form-group[data-label=${key}]>input`).val(data.value);
                    if(data.label=='每隔几天' || data.label == '每隔几周') {
                        data.value = 0;
                    }
                } else if (type == 'Radio') {
                    let value = data['field_content'][data['value']];
                    if(value){
                        $el.find(`.form-group input[data-label=${value}]`)[0].checked = true;
                    }else {
                        data.value = data['group'][0]['value'];
                    }
                }else if(type == 'MultiSelect'){
                    if(data.label == '收件人') {
                        let choosedUsersName =data.options.map((item) => {
                            return item.label;
                        });
                        this.data.choosedUsers  = data.value;
                        this.actions.showChoosedUsersName(choosedUsersName);
                    }else if(data.label == '提醒方式'){
                        if(data.value && data.value.length>0){
                            data.value.forEach(item=>{
                                $el.find(`.form-group input[data-label=${data['field_content'][item]}]`)[0].checked = true;
                            })
                           this.data.reminder = new Set(data.value);
                        }
                    }
                    this.actions.requiredChange(key);
                }else if(type == 'Textarea'){
                    data.value = data.value.split(`${this.data.separator}来自`)[0] || '';
                    $el.find(`.form-group[data-label=${key}]>textarea`).val( data.value);
                }
                this.actions.requiredChange(key,data.value);
            }
            if(this.data.is_view) {
                this.actions.toView();
            }
        },
        //初始化值
        initValue(res,formData ){
            let json = this.data.obj;
            json.temp_id = res[1].data.temp_id.value || '';
            if(json.is_view) {
                this.data.is_view = true;
            }
            if(json.btnType != 'new') {
                let data1 = formData['提醒周期'];
                let data2 = formData['每月提醒方式'];
                this.data.cycle = data1.field_content[data1['value']] || '一次';
                this.data.cycleMonth = data2.field_content[data2['value']] || '按天提醒';
            }
        },
        //查看模式
        toView(){
           this.el.find('#save').hide();
           let formGroup =  this.el.find('.form-group');
           for(let i=0; i <formGroup .length; i++ ) {
                $(formGroup [i]).addClass('isDisabled');
           }
        },
        //初始化渲染组件
        initControls(){
            let formData = this.data.formData;
            let arrRadio = ['提醒周期','执行设置'];
            let arrMultiSelect = ['提醒方式'];
            this.actions.renderDateTime(formData);
            this.actions.renderRadio(arrRadio,formData);
            this.actions.renderMultiSelect(arrMultiSelect,formData);
            this.actions.renderBuildin('发件人',formData);
            this.actions.renderCycleSettings('提醒周期');
        },
        //渲染开始/结束时间
        renderDateTime(formData){
            let changeValueStart =(res=>{
                this.actions.changeValue('开始时间',res.value);
            })
            let changeValueEnd =(res=>{
                this.actions.changeValue('结束时间',res.value);
            })
            let dataTimeControl1 = new dataTimeControl({data:{value: formData['开始时间'].value || '',isAgGrid:true},events:{changeValue:changeValueStart}});
            let dataTimeControl2 = new dataTimeControl({data:{value: formData['结束时间'].value || '',isAgGrid:true},events:{changeValue:changeValueEnd}});
            this.append(dataTimeControl1,this.el.find('.startTime'));
            this.append(dataTimeControl2,this.el.find('.endTime'));
        },
        //渲染提醒周期，执行设置
        renderRadio(arr,formData){
            arr.forEach(item=>{
                let $el = this.el.find(`.form-group[data-label=${item}]>div`);
                $el.empty();
                let $html = '';
                let group = formData[item]['group'];
                group.forEach(gp=>{
                    $html+=` <label class="custom-radio">
                                <input type="radio" name="${item}" data-label="${gp.label}" value="${gp.value}">
                                <span class="select-prompt">${gp.label}</span>
                            </label>`
                })
                $el.append($html);
                $el.find("input[type=radio]")[0].checked = true;
            })
        },
        //渲染提醒方式
        renderMultiSelect(arr,formData){
            arr.forEach(item=>{
                let $el = this.el.find(`.form-group[data-label=${item}]>div`);
                $el.empty();
                let $html = '';
                let group = formData[item]['options'];
                group.forEach(gp=>{
                    $html+=` <label class="custom-checkbox">
                                <input type="checkbox" name="${item}" data-label="${gp.label}" value="${gp.value}">
                                <span class="select-prompt">${gp.label}</span>
                            </label>`
                })
                $el.append($html);
            })
        },
        //渲染发件人
        async renderBuildin(label,formData){
           let res  = await FormService.getFormStaticBuildinData(this.data.postData);
           let data = res.buildin_options[formData[label]['dfield']];
           let list =await this.actions.pickSelectData(data);
           let choosed = this.actions.pickSelectData(formData[label].options);
           let _this = this;
           let selectDom = new AutoSelect({
                data:{
                    list: list,
                    choosed: choosed || [],
                    multiSelect: false,
                    width:'240px',
                },
                events: {
                    onSelect:function(choosed) {
                        if(choosed.length) {
                            _this.data.sender = choosed[0].name;
                        }
                      _this.actions.changeChoosedData(label,choosed);
                    }
                }
            })
            this.append(selectDom ,this.el.find(`.form-group[data-label=${label}]>div`));
        },
        //渲染提醒周期
        renderCycleSettings(label){
           let formData = this.data.formData;
            let cyclLists={
                'time':true,
                'day':false,
                'week':false,
                'month':false
            };
           cyclLists= this.actions.pickChoosedLabel('cycle',cyclLists);
           if(cycleSettings) {
               cycleSettings.destroySelf();
           }
           this.el.find('.cycle-right').empty();
           let _this = this;
           let cycleSettings = new CycleSettings(
               {
                   data: {
                       cycle: cyclLists,
                       formData:formData,
                       fontsize:this.data.fontsize
                   },
                   events:{
                       changeValue(key,val){
                           _this.actions.changeValue(key,val);
                       },
                       changeChoosedData(label,choosed){
                           _this.actions.changeChoosedData(label,choosed);
                       },
                       requiredChange(key,val){
                           _this.actions.requiredChange(key,val);
                       }
                   }
               });
            cycleSettings.render(this.el.find('.cycle-right'));
            this.actions.requireMonthSettings();
        },
        //切换提醒周期设置重新渲染
        pickChoosedLabel(type,lists){
            let label = this.data[`translate${type}`][this.data[type]];
            for(let i in lists) {
                lists[i] = (i== label);
            }
           return lists;
        },
        //值变换，赋值
        changeValue(key,val){
           this.data.formData[key].value = val || '';
           this.actions.requiredChange(key,val);
        },
        //必填性改变
        requiredChange(label,val='') {
           let $el = this.el.find(`.form-group[data-label=${label}] .required`);
           if(!$el.length) return;
           if(val === ''|| val=='undefined' || val.length === 0 || JSON.stringify(val) === "{}") {
               $el.removeClass('required2' + this.data.fontsize).addClass('required1' + this.data.fontsize);
           }else {
               $el.removeClass('required1' + this.data.fontsize).addClass('required2' + this.data.fontsize);
           }
        },
        requireMonthSettings(){
           if(this.data.cycle != '每月') return;
            let monthArr = this.data.monthArr;
            let changeArr = this.data.monthSettings[this.data.cycleMonth];
            monthArr.forEach(item=>{
                let dom = this.el.find(`.form-group[data-label=${item}]`).find('.required');
                changeArr.includes(item) ? dom.hide() : dom.show();
            })
        },
        //封装选择类型choosed数据
        changeChoosedData(label,choosed=[]){
            let arr = [];
            arr =choosed.map((item) => {
                return item.id;
            });
            this.actions.changeValue(label,arr);
        },
        //封装下拉选项数据
        pickSelectData(options){
            let arr = [];
            options.forEach(item=>{
                let obj = {};
                obj['id'] = item.value;
                obj['name'] = item.label;
                obj['py'] = item.py;
                if(item.value) {
                    arr.push(obj);
                }
            })
            return arr;
        },
        /**
         * 打开选择人员列表
         */
       openGetUsers() {
            PMAPI.openDialogByIframe('/iframe/PostMessageGetUsers',{
                width: 540,
                height: 600,
                maxable: false,
                title: '选择人员'
            },{
                data:this.data.departmentData,
                choosedUsers:this.data.choosedUsers
            }).then(res=>{
                if(!res.onlyclose){
                    this.actions.changeChoosedData('收件人',res.choosedUsers);
                    let choosedUsersName = res.choosedUsers.map((item) => {
                        return item.name;
                    });
                    this.data.choosedUsers = res.choosedUsers.map((item) => {
                        return item.id;
                    });
                    this.actions.showChoosedUsersName(choosedUsersName,'收件人');
                }
            })
        },
        /**
         *收件人不足五人的情况下，就全部显示人名，超过五个人，就显示前五个人的人名加上收件人人数
         */
        showChoosedUsersName (choosedUsersName) {
            let showChoosedUsersName = choosedUsersName
            let count = choosedUsersName.length
            if(count > 4) {
                showChoosedUsersName = choosedUsersName.slice(0,4)
                this.el.find('.recipients').val(showChoosedUsersName+`   共${count}人`)
            }else{
                this.el.find('.recipients').val(showChoosedUsersName)
            }
            this.el.find('.recipients').attr('title',choosedUsersName);
        },
        /**
         *获取部门人员数据
         */
       getDepartmentData () {
            HTTP.getImmediately('/get_department_tree/', {type: ''}).then((res) => {
                if(res.success === 1) {
                    this.data.departmentData = res.data;
                    this.actions.openGetUsers();
                }
            })
        },
        /**
         * 检查必填性
         */
       checkData( formData ){
           let $form = this.el.find('.form-group');
           let needVaildArr = new Set();
           let state = true;
           let errArr= [];
           let errorMsg = "";
           for(let i=0; i<$form.length; i++) {
               let dataLabel = $($form[i]).attr('data-label');
               needVaildArr.add(dataLabel);
           }
           //去掉不需要验证必填的字段
            if(this.data.cycle == '每月') {
                let delArr = this.data.monthSettings[this.data.cycleMonth];
                needVaildArr.add('每月提醒方式');
                delArr.forEach(item=>{
                    needVaildArr.delete(item);
                })
            }
            this.data.ignoreLabels.forEach(item=>{
                needVaildArr.delete(item);
            })
           needVaildArr = Array.from(needVaildArr);
           needVaildArr.forEach(item=>{
               let data =formData[item];
               if(data === '' || data.value.length === 0 || JSON.stringify(data.value) === "{}" || JSON.stringify(data.value) === '[""]') {
                   state = false;
                   errArr.push(data["label"] + '是必填项!');
                   errorMsg = errArr.join(' ');
               }else {
                   //验证正则
                   if(data.type == 'Input' && data.reg) {
                       let reg = data.reg;
                       let regReg = new RegExp(data.reg);
                       for (let r in reg) {
                           let regReg;
                           if (r.startsWith('/') && r.endsWith('/')) {
                               regReg = eval(r);
                           }else {
                               regReg = new RegExp(r);
                           }
                           let flag = regReg.test(data.value);
                           if (!flag) {
                               state = false;
                               errArr.push(reg[r]);
                               errorMsg = errArr.join(' ');
                           }
                       }
                   }
               }
           })
          return {
              state:state,
              errorMsg:errorMsg,
              needVaildArr:needVaildArr
          }
        },
       getCurrentData(formData,needVaildArr){
           let ignoreFields =this.data.ignoreFields;
           let ignoreLabels =this.data.ignoreLabels;
           let arr = needVaildArr.concat(ignoreLabels);
            for(let i in formData ) {
                let data = formData[i];
                if(!arr.includes(i)  && !ignoreFields.includes(data.dfield)) {
                    formData[i].value = "";
                }
            }
            return formData;
        },
       createFormValue(data){
            let obj = {};
            let objData = this.data.obj;
            let json = {
                table_id: objData.table_id,
                parent_table_id: objData.parent_table_id || "",
                parent_real_id: objData.parent_real_id || "",
                parent_temp_id: objData.parent_temp_id || "",
                real_id: objData.real_id || "",
                temp_id: objData.temp_id || "",
            }
            data['正文'].value = data['正文'].value + `${this.data.separator}来自${this.data.sender}`;
            for (let i in data) {
                if(data[i]['dfield']) {
                    obj[data[i]['dfield']] =  data[i]['value'];
                }else {
                    obj[i] =  data[i];
                }
            }
            _.defaultsDeep(obj, json);
            return obj;
        },
        /**
         * 提交表单
        */
        async submitData(){
            let formData = this.data.formData;
            let{ state, errorMsg, needVaildArr} = this.actions.checkData( formData );
            if(!state) {
                MSG.alert(errorMsg);
                this.data.isBtnClick = false;
                return;
            }
            formData = this.actions.getCurrentData( formData,needVaildArr );
            let postData = this.actions.createFormValue( formData);
            let json = {
                data: JSON.stringify(postData),
                table_id: this.data.obj.table_id,
                parent_table_id: this.data.obj.parent_table_id || "",
                parent_real_id: this.data.obj.parent_real_id || "",
                parent_temp_id: this.data.obj.parent_temp_id || "",
            }
            let res = await FormService.saveAddpageData(json);
            if(res.success === 1) {
                //表单提交成功,通知aggrid刷新
                Mediator.publish('remind-form:save-success');
                this.data.isBtnClick = false;
                agGridOpenForm.hide();
            }else {
                MSG.alert(res.error);
                this.data.isBtnClick = false;
            }
        }
    },
    async  afterRender() {
        this.showLoading();
        await this.actions.createFormData();
    },
    beforeDestory(){
        Mediator.removeAll('remind-form:save-success');
    }
}
let FormBanner = Component.extend(config);

let agGridOpenForm = {
    el: null,
    show: function (config = {}) {
        this.el = $("<div class='form-banner'>").appendTo('body');
        let formBanner = new FormBanner(config);
        formBanner.render(this.el);
        this.el.erdsDialog({
            width: 600,
            height: 640,
            modal: true,
            maxable: false,
            defaultMax: false,
            title: '新增提醒',
            close: function () {
                $(this).erdsDialog('destroy');
                Mediator.removeAll('remind-form:save-success');
                formBanner._destroy();
            }
        })
    },
    hide:function () {
        this.el.erdsDialog('close');
    }
}

export {agGridOpenForm}


// WEBPACK FOOTER //
// app/components/customPage/remind-todo/remind-todo.js